(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[49354,53120],{

/***/ 467327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BJ": function() { return /* binding */ CUSTOM_HAMPER_LOCAL_STORAGE_KEY; },
/* harmony export */   "Qi": function() { return /* binding */ HAMPER_PAGE_SIZE; },
/* harmony export */   "Qj": function() { return /* binding */ CUSTOM_HAMPER_LOCAL_STORAGE_APP_KEY; }
/* harmony export */ });
const CUSTOM_HAMPER_LOCAL_STORAGE_KEY = "buildHamper";
const CUSTOM_HAMPER_LOCAL_STORAGE_APP_KEY = "buildHamperApp";
const HAMPER_PAGE_SIZE = 20;


/***/ }),

/***/ 626650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ HamperProvider; },
/* harmony export */   "h": function() { return /* binding */ useHamper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_cart_v2__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(916476);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(420577);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(535820);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(775002);
/* harmony import */ var _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(735090);
/* harmony import */ var _terra_js_terra_kit_dist_common_CommonKitModule__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(338867);
/* harmony import */ var _terra_js_terra_kit_dist_common_CommonKitModule__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_terra_js_terra_kit_dist_common_CommonKitModule__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(467327);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(282116);
/* harmony import */ var helpers_page_actions__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(347822);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(88837);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(634655);
/* harmony import */ var modules_cart_CartContextV2__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(534090);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(891987);
/* harmony import */ var _GlobalDataContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(684443);
/* harmony import */ var _ServiceContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(643015);
/* harmony import */ var _ToastContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(508285);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};

















const initialState = {
    hamperData: {
        configs: [
            {
                quantity: 0
            },
            {
                quantity: 0
            },
            {
                quantity: 0
            },
            {
                quantity: 0
            },
            {
                quantity: 0
            }, 
        ],
        activeIndex: 0,
        hampers: []
    },
    currentHamperConfig: {
        quantity: 1
    },
    changeActiveConfig: ()=>{},
    updateCurrentConfig: ()=>{},
    onUpdateConfig: ()=>Promise.resolve(),
    increaseHamperItemQuantity: ()=>{},
    decreaseHamperItemQuantity: ()=>{},
    removeHamperItem: ()=>{},
    setHamperItemQuantity: ()=>{},
    increaseCurrentHamperQuantity: ()=>{},
    decreaseCurrentHamperQuantity: ()=>{},
    setCurrentHamperQuantity: ()=>{},
    hamperDetailProducts: {
        products: [],
        filters: {},
        pagination: {
            totalItems: 0,
            totalPages: 0
        }
    },
    loading: false,
    addHamper: ()=>{},
    minusHamper: ()=>{},
    removeHamper: ()=>{},
    onChangeQuantityHamper: ()=>{},
    productHampers: [],
    setProductHampers: ()=>{},
    priceSummary: [],
    priceAvailableHamper: 0,
    allPriceSummary: 0,
    handleBuyNowHamper: ()=>Promise.resolve(),
    availableHamper: []
};
const HamperContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_5__.createContext)(initialState);
const HamperProvider = (param)=>{
    let { children  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const { bomMapping , isMobile  } = (0,_GlobalDataContext__WEBPACK_IMPORTED_MODULE_6__/* .useTenantConfig */ .Wx)();
    const { discoveryServiceV2  } = (0,_ServiceContext__WEBPACK_IMPORTED_MODULE_7__/* .useServices */ .Su)();
    const { onAddMultipleItems  } = (0,modules_cart_CartContextV2__WEBPACK_IMPORTED_MODULE_8__/* .useCartV2 */ .T6)();
    const toast = (0,_ToastContext__WEBPACK_IMPORTED_MODULE_9__/* .useToast */ .p)();
    const { 0: loading , 1: setLoading  } = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false);
    const { 0: hamperData , 1: setHamperData  } = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)((0,helpers__WEBPACK_IMPORTED_MODULE_10__/* .getHamperDataLocalConfigs */ .TK)());
    const { 0: productHampers , 1: setProductHampers  } = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)([]);
    const currentHamperConfig = (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(()=>{
        return hamperData.configs[hamperData.activeIndex];
    }, [
        hamperData
    ]);
    // get all skus from current active config
    const currentConfigSkus = (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(()=>{
        const skus = [];
        hamperData.configs.forEach((hamperConfig)=>{
            Object.keys(hamperConfig).forEach((configKey)=>{
                const listProduct = hamperConfig[configKey];
                if (Array.isArray(listProduct)) {
                    listProduct.forEach((p)=>{
                        if (!!p.sku && !skus.includes(p.sku)) {
                            skus.push(p.sku);
                        }
                    });
                }
            });
        });
        return skus;
    }, [
        hamperData
    ]);
    // update all local storage config when current config changes
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        const hamperKey = _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_2__/* ["default"].isAvailable */ .Z.isAvailable() ? constants_index__WEBPACK_IMPORTED_MODULE_11__/* .CUSTOM_HAMPER_LOCAL_STORAGE_APP_KEY */ .Qj : constants_index__WEBPACK_IMPORTED_MODULE_11__/* .CUSTOM_HAMPER_LOCAL_STORAGE_KEY */ .BJ;
        localStorage.setItem(hamperKey, JSON.stringify(hamperData));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        JSON.stringify(hamperData)
    ]);
    // trigger update quantity of custom hamper -> when user selects material, set quantity of custom hamper = 1
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        var ref;
        const currentHamperHasConfig = Object.values(hamperData.configs[hamperData.activeIndex]).some((config)=>Array.isArray(config) && config.length > 0);
        if (currentHamperHasConfig && !((ref = hamperData.configs[hamperData.activeIndex]) === null || ref === void 0 ? void 0 : ref.quantity)) {
            setHamperData(_objectSpreadProps(_objectSpread({}, hamperData), {
                configs: hamperData.configs.map((config, index)=>{
                    // check if config is the active config
                    if (hamperData.activeIndex === index) {
                        return _objectSpreadProps(_objectSpread({}, config), {
                            quantity: 1
                        });
                    }
                    return config;
                })
            }));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        JSON.stringify(hamperData.configs[hamperData.activeIndex])
    ]);
    const changeActiveConfig = (activeIndex)=>{
        setHamperData(_objectSpreadProps(_objectSpread({}, hamperData), {
            activeIndex
        }));
    };
    const updateCurrentConfig = (newConfig, targetIndex)=>{
        const currentIndex = targetIndex !== undefined ? targetIndex : hamperData.activeIndex;
        setHamperData(_objectSpreadProps(_objectSpread({}, hamperData), {
            configs: hamperData.configs.map((config, index)=>{
                // check if config is the active config
                if (index === currentIndex) {
                    // replace with new config
                    return _objectSpreadProps(_objectSpread({}, newConfig), {
                        quantity: (0,_teko_utils__WEBPACK_IMPORTED_MODULE_12__/* .isEmptyObject */ .Q)(newConfig) ? 0 : config.quantity || 0
                    });
                }
                return config;
            }),
            activeIndex: currentIndex
        }));
    };
    const onUpdateConfig = async (product)=>{
        var ref;
        const targetIndex = hamperData.configs.findIndex((item)=>item.quantity <= 0);
        if (targetIndex === -1) {
            var ref1;
            toast === null || toast === void 0 ? void 0 : (ref1 = toast.error) === null || ref1 === void 0 ? void 0 : ref1.call(toast, {
                message: (0,i18n__WEBPACK_IMPORTED_MODULE_13__.t)("Mỗi giỏ h\xe0ng chỉ được chọn 5 giỏ qu\xe0 tự chọn!"),
                title: undefined
            });
            return;
        }
        (0,helpers_page_actions__WEBPACK_IMPORTED_MODULE_14__/* .scrollSmoothToIdWithOffset */ .A)("hamper-item-block", isMobile ? 55 : 90);
        if (!((ref = product.materials) === null || ref === void 0 ? void 0 : ref.length) || !bomMapping || (0,_teko_utils__WEBPACK_IMPORTED_MODULE_12__/* .isEmptyObject */ .Q)(bomMapping)) {
            return;
        }
        try {
            setLoading(true);
            // get all material skus of current product
            const materialSkus = product.materials.map((material)=>material.sku);
            // call api search-skus-v2 to get materials categories for mapping
            const data = await discoveryServiceV2.search({
                pageSize: materialSkus.length,
                filter: {
                    skus: materialSkus
                }
            });
            const materialProducts = data.products;
            const bomMappingKeys = !!bomMapping && !(0,_teko_utils__WEBPACK_IMPORTED_MODULE_12__/* .isEmptyObject */ .Q)(bomMapping) ? Object.keys(bomMapping) : [];
            const visited = new Map();
            const newConfig = bomMappingKeys.reduce((config, currentKey)=>{
                // Get defined hamper mapping categories from tenant config
                const currentMappingCategories = bomMapping[currentKey].categories;
                const productsByKey = [];
                materialProducts === null || materialProducts === void 0 ? void 0 : materialProducts.forEach((materialProduct)=>{
                    var ref;
                    // Check if any categories from materialProducts included in current key mapping categories
                    const matchedCategory = (ref = materialProduct.categories) === null || ref === void 0 ? void 0 : ref.find((category)=>{
                        return currentMappingCategories.find((mappingCategory)=>{
                            return mappingCategory === category.code;
                        });
                    });
                    // // if exists, add material sku & quantity to new config
                    if (!!matchedCategory && !!materialProduct.sku) {
                        var ref1;
                        // find material quantity in product's materials by sku
                        const matchedMaterial = (ref1 = product.materials) === null || ref1 === void 0 ? void 0 : ref1.find((material)=>material.sku === materialProduct.sku);
                        if (!!matchedMaterial && !visited.has(matchedMaterial.sku)) {
                            productsByKey.push({
                                sku: materialProduct.sku,
                                quantity: matchedMaterial.quantity
                            });
                            visited.set(matchedMaterial.sku, true);
                        }
                    }
                });
                config[currentKey] = productsByKey;
                return config;
            }, {});
            if (!(0,_teko_utils__WEBPACK_IMPORTED_MODULE_12__/* .isEmptyObject */ .Q)(newConfig)) {
                updateCurrentConfig(newConfig, targetIndex !== -1 ? targetIndex : undefined);
                if (targetIndex !== -1) {
                    var ref2;
                    toast === null || toast === void 0 ? void 0 : (ref2 = toast.success) === null || ref2 === void 0 ? void 0 : ref2.call(toast, {
                        message: "".concat((0,i18n__WEBPACK_IMPORTED_MODULE_13__.t)("Xem chi tiết v\xe0 chỉnh sửa giỏ qu\xe0 tự chọn"), " ").concat(targetIndex + 1),
                        title: undefined
                    });
                }
            }
        } catch (error) {
            _teko_log__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .k.error(error);
        } finally{
            setLoading(false);
        }
    };
    // call api search-skus-v2 to get all current active config skus detail info
    const { result: hamperDetailProducts , isLoading  } = (0,hooks__WEBPACK_IMPORTED_MODULE_15__/* .useSearch */ .Rx)((0,_teko_utils__WEBPACK_IMPORTED_MODULE_16__.cleanObject)(!!currentConfigSkus.length ? {
        pageSize: currentConfigSkus.length,
        filter: {
            skus: currentConfigSkus
        }
    } : {}));
    const increaseHamperItemQuantity = (hamperItemKey, sku)=>{
        const configs = hamperData.configs.map((config, index)=>{
            // check if config is the active config
            if (hamperData.activeIndex !== index) return config;
            const currentConfigHamperItem = config[hamperItemKey] || [];
            const isNewSkuAdded = currentConfigHamperItem.length && !currentConfigHamperItem.find((h)=>h.sku === sku);
            // Add new key if not exists or add multiple items
            if (!currentConfigHamperItem.length || isNewSkuAdded) {
                return _objectSpreadProps(_objectSpread({}, config), {
                    [hamperItemKey]: [
                        ...currentConfigHamperItem,
                        {
                            sku,
                            quantity: 1
                        }
                    ]
                });
            }
            return _objectSpreadProps(_objectSpread({}, config), {
                [hamperItemKey]: currentConfigHamperItem.map((h)=>{
                    if (h.sku === sku) {
                        return _objectSpreadProps(_objectSpread({}, h), {
                            quantity: h.quantity + 1
                        });
                    }
                    return h;
                })
            });
        });
        setHamperData(_objectSpreadProps(_objectSpread({}, hamperData), {
            configs
        }));
    };
    const decreaseHamperItemQuantity = (hamperItemKey, sku)=>{
        setHamperData(_objectSpreadProps(_objectSpread({}, hamperData), {
            configs: hamperData.configs.map((config, index)=>{
                // check if config is the active config
                if (hamperData.activeIndex === index) {
                    const currentConfigHamperItem = config[hamperItemKey];
                    return _objectSpreadProps(_objectSpread({}, config), {
                        [hamperItemKey]: currentConfigHamperItem.map((h)=>{
                            if (h.sku === sku) {
                                return _objectSpreadProps(_objectSpread({}, h), {
                                    quantity: h.quantity - 1
                                });
                            }
                            return h;
                        })
                    });
                }
                return config;
            })
        }));
    };
    const removeHamperItem = (hamperItemKey, sku)=>{
        setHamperData(_objectSpreadProps(_objectSpread({}, hamperData), {
            configs: hamperData.configs.map((config, index)=>{
                // check if config is the active config
                if (hamperData.activeIndex === index) {
                    const { [hamperItemKey]: _ , quantity  } = config, remainingConfig = _objectWithoutProperties(config, [
                        hamperItemKey,
                        "quantity"
                    ].map(_toPropertyKey));
                    const selectedValue = config[hamperItemKey].filter((h)=>h.sku !== sku);
                    // check if remaining config is empty (has no material products) after remove item
                    const isEmptyConfig = Object.values(remainingConfig).every((item)=>item.length === 0) && !selectedValue.length;
                    return _objectSpreadProps(_objectSpread({}, remainingConfig), {
                        [hamperItemKey]: selectedValue,
                        quantity: isEmptyConfig ? 0 : quantity
                    });
                }
                return config;
            })
        }));
    };
    const setHamperItemQuantity = (hamperItemKey, quantity, sku)=>{
        // stop when input quantity is 0
        if (!quantity) {
            return;
        }
        setHamperData(_objectSpreadProps(_objectSpread({}, hamperData), {
            configs: hamperData.configs.map((config, index)=>{
                // check if config is the active config
                if (hamperData.activeIndex === index) {
                    const currentConfigHamperItem = config[hamperItemKey];
                    return _objectSpreadProps(_objectSpread({}, config), {
                        [hamperItemKey]: currentConfigHamperItem.map((h)=>{
                            if (h.sku === sku) {
                                return _objectSpreadProps(_objectSpread({}, h), {
                                    quantity: quantity
                                });
                            }
                            return h;
                        })
                    });
                }
                return config;
            })
        }));
    };
    const increaseCurrentHamperQuantity = (targetIndex)=>{
        const currentIndex = targetIndex !== undefined ? targetIndex : hamperData.activeIndex;
        setHamperData(_objectSpreadProps(_objectSpread({}, hamperData), {
            configs: hamperData.configs.map((config, index)=>{
                // check if config is the active config
                if (index === currentIndex) {
                    return _objectSpreadProps(_objectSpread({}, config), {
                        quantity: config.quantity + 1
                    });
                }
                return config;
            })
        }));
    };
    const decreaseCurrentHamperQuantity = (targetIndex)=>{
        const currentIndex = targetIndex !== undefined ? targetIndex : hamperData.activeIndex;
        setHamperData(_objectSpreadProps(_objectSpread({}, hamperData), {
            configs: hamperData.configs.map((config, index)=>{
                // check if config is the active config
                if (index === currentIndex) {
                    const quantity = config.quantity - 1;
                    let data = _objectSpread({}, config);
                    delete data.quantity; // only get configs
                    // if quantity less than or equal 0, reset all configs to empty array
                    if (quantity <= 0) {
                        data = Object.keys(data).reduce((obj, key)=>{
                            obj[key] = [];
                            return obj;
                        }, {});
                    }
                    return _objectSpreadProps(_objectSpread({}, data), {
                        quantity
                    });
                }
                return config;
            })
        }));
    };
    const setCurrentHamperQuantity = (quantity, targetIndex)=>{
        const currentIndex = targetIndex !== undefined ? targetIndex : hamperData.activeIndex;
        // stop when input quantity is 0
        if (!quantity) {
            return;
        }
        setHamperData(_objectSpreadProps(_objectSpread({}, hamperData), {
            configs: hamperData.configs.map((config, index)=>{
                // check if config is the active config
                if (index === currentIndex) {
                    return _objectSpreadProps(_objectSpread({}, config), {
                        quantity
                    });
                }
                return config;
            })
        }));
    };
    const addHamper = (sku)=>{
        var ref, ref1;
        const currentHamperIndex = hamperData === null || hamperData === void 0 ? void 0 : (ref = hamperData.hampers) === null || ref === void 0 ? void 0 : ref.findIndex((h)=>h.sku === sku);
        const newHampers = currentHamperIndex === -1 ? [
            ...(hamperData === null || hamperData === void 0 ? void 0 : hamperData.hampers) || [],
            {
                sku,
                quantity: 1
            }
        ] : hamperData === null || hamperData === void 0 ? void 0 : (ref1 = hamperData.hampers) === null || ref1 === void 0 ? void 0 : ref1.map((h)=>{
            if (h.sku === sku) {
                return _objectSpreadProps(_objectSpread({}, h), {
                    quantity: (h.quantity || 0) + 1
                });
            }
            return h;
        });
        setHamperData(_objectSpreadProps(_objectSpread({}, hamperData), {
            hampers: newHampers
        }));
    };
    const minusHamper = (sku)=>{
        var ref, ref1;
        const currentHamperIndex = hamperData === null || hamperData === void 0 ? void 0 : (ref = hamperData.hampers) === null || ref === void 0 ? void 0 : ref.findIndex((h)=>h.sku === sku);
        if (currentHamperIndex === -1) {
            return;
        }
        const newHampers = hamperData === null || hamperData === void 0 ? void 0 : (ref1 = hamperData.hampers) === null || ref1 === void 0 ? void 0 : ref1.map((h)=>{
            if (h.sku === sku) {
                return _objectSpreadProps(_objectSpread({}, h), {
                    quantity: (h.quantity || 0) - 1
                });
            }
            return h;
        });
        setHamperData(_objectSpreadProps(_objectSpread({}, hamperData), {
            hampers: newHampers
        }));
    };
    const removeHamper = (sku)=>{
        var ref;
        const newHampers = hamperData === null || hamperData === void 0 ? void 0 : (ref = hamperData.hampers) === null || ref === void 0 ? void 0 : ref.filter((h)=>{
            return h.sku !== sku;
        });
        setHamperData(_objectSpreadProps(_objectSpread({}, hamperData), {
            hampers: newHampers
        }));
    };
    const onChangeQuantityHamper = (sku, quantity)=>{
        var ref, ref1, ref2;
        if (!quantity) {
            return;
        }
        const currentHamperIndex = hamperData === null || hamperData === void 0 ? void 0 : (ref = hamperData.hampers) === null || ref === void 0 ? void 0 : ref.findIndex((h)=>h.sku === sku);
        if (currentHamperIndex === -1) {
            return;
        }
        const newHampers = quantity !== 0 ? hamperData === null || hamperData === void 0 ? void 0 : (ref1 = hamperData.hampers) === null || ref1 === void 0 ? void 0 : ref1.map((h)=>{
            if (h.sku === sku) {
                return _objectSpreadProps(_objectSpread({}, h), {
                    quantity
                });
            }
            return h;
        }) : hamperData === null || hamperData === void 0 ? void 0 : (ref2 = hamperData.hampers) === null || ref2 === void 0 ? void 0 : ref2.filter((h)=>h.sku !== sku);
        setHamperData(_objectSpreadProps(_objectSpread({}, hamperData), {
            hampers: newHampers
        }));
    };
    // price summary
    const priceSummary = (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(()=>{
        return hamperData.configs.map((currentHamperData, index)=>{
            const bomMappingKeys = !!bomMapping && !(0,_teko_utils__WEBPACK_IMPORTED_MODULE_12__/* .isEmptyObject */ .Q)(bomMapping) ? Object.keys(bomMapping) : [];
            const mapQuantity = new Map();
            const products = [];
            bomMappingKeys === null || bomMappingKeys === void 0 ? void 0 : bomMappingKeys.forEach((key)=>{
                var ref;
                const skus = [];
                const dataHamper = currentHamperData[key] || [];
                dataHamper.forEach((h)=>{
                    skus.push(h.sku);
                    mapQuantity.set(h.sku, h.quantity);
                });
                (ref = hamperDetailProducts.products) === null || ref === void 0 ? void 0 : ref.forEach((p)=>{
                    if (skus.includes(p.sku)) {
                        products.push(_objectSpreadProps(_objectSpread({}, p), {
                            quantity: mapQuantity.get(p.sku) || 0
                        }));
                    }
                });
            });
            return {
                price: (products === null || products === void 0 ? void 0 : products.reduce((prev, cur)=>{
                    var ref;
                    return prev + (((ref = cur.price) === null || ref === void 0 ? void 0 : ref.latestPrice) || 0) * (cur.quantity || 0);
                }, 0)) * ((currentHamperData === null || currentHamperData === void 0 ? void 0 : currentHamperData["quantity"]) || 0),
                index,
                products,
                quantity: (currentHamperData === null || currentHamperData === void 0 ? void 0 : currentHamperData["quantity"]) || 0
            };
        }).filter((item)=>item.price > 0) || [];
    }, [
        hamperData,
        bomMapping,
        hamperDetailProducts
    ]);
    const allPriceSummary = (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(()=>{
        return priceSummary.reduce((prev, cur)=>prev + cur.price, 0);
    }, [
        priceSummary
    ]);
    const priceAvailableHamper = (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(()=>{
        return (hamperData.hampers || []).reduce((prev, cur)=>{
            var ref, ref1;
            const { sku , quantity =0  } = cur;
            const price = ((ref = productHampers.find((p)=>p.sku === sku)) === null || ref === void 0 ? void 0 : (ref1 = ref.price) === null || ref1 === void 0 ? void 0 : ref1.latestPrice) || 0;
            return prev + price * quantity;
        }, 0);
    }, [
        hamperData,
        productHampers
    ]);
    const availableHamper = (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(()=>{
        return (hamperData.hampers || []).map((h)=>{
            var ref;
            const product = productHampers.find((p)=>p.sku === h.sku) || {
                imageUrl: "",
                name: "",
                price: {
                    latestPrice: 0
                }
            };
            return {
                imageUrl: product === null || product === void 0 ? void 0 : product.imageUrl,
                quantity: h.quantity,
                name: product === null || product === void 0 ? void 0 : product.name,
                sku: h.sku,
                price: (product === null || product === void 0 ? void 0 : (ref = product.price) === null || ref === void 0 ? void 0 : ref.latestPrice) || 0
            };
        }).filter((ah)=>!!ah.price && !!ah.quantity);
    }, [
        hamperData,
        productHampers
    ]) || [];
    const handleBuyNowHamper = async ()=>{
        try {
            var ref;
            // add item to cart
            const productsAddToCart = [];
            // calculate hamper build sẵn
            const skuAvailableHamper = productHampers.map((p)=>p.sku);
            const productHampersAddToCart = hamperData.hampers ? hamperData.hampers.filter((p)=>p.quantity !== 0 && !!skuAvailableHamper.includes(p.sku)) // clear các sảm phẩm trong giỏ quà build sẵn mà không thuộc siêu thị hiện tại, và có số lượng = 0
            .map((item)=>{
                var ref;
                return {
                    sku: item.sku,
                    quantity: item.quantity,
                    promotionId: ((ref = productHampers.find((p)=>p.sku === item.sku)) === null || ref === void 0 ? void 0 : ref.selectPromotionId) || undefined
                };
            }) : [];
            // calculate custom hampers
            const customHamperSkus = [];
            hamperData.configs.filter((config)=>{
                return !!(config === null || config === void 0 ? void 0 : config["quantity"]) && (config === null || config === void 0 ? void 0 : config["quantity"]) !== 0;
            }) // loại những config có số lượng = 0
            .forEach((hamperConfig)=>{
                Object.keys(hamperConfig).forEach((configKey)=>{
                    const skus = hamperConfig[configKey];
                    if (Array.isArray(skus)) {
                        skus.forEach((param)=>{
                            let { sku , quantity  } = param;
                            customHamperSkus.push({
                                sku: sku,
                                quantity: quantity * ((hamperConfig === null || hamperConfig === void 0 ? void 0 : hamperConfig["quantity"]) || 0)
                            });
                        });
                    }
                });
            });
            const skuHamperDetailProducts = hamperDetailProducts === null || hamperDetailProducts === void 0 ? void 0 : (ref = hamperDetailProducts.products) === null || ref === void 0 ? void 0 : ref.map((p)=>p.sku);
            const customHamperSkusAddToCart = customHamperSkus.filter((h)=>h.quantity !== 0 && !!skuHamperDetailProducts.includes(h.sku)) // clear hết các sku không thuộc siêu thị hiện tại và có số lượng = 0
            .map((item)=>{
                var ref, ref1;
                return {
                    sku: item.sku,
                    quantity: item.quantity,
                    promotionId: ((ref1 = (ref = hamperDetailProducts.products) === null || ref === void 0 ? void 0 : ref.find((p)=>p.sku === item.sku)) === null || ref1 === void 0 ? void 0 : ref1.selectPromotionId) || undefined
                };
            });
            productsAddToCart.push(...productHampersAddToCart, ...customHamperSkusAddToCart);
            await onAddMultipleItems(productsAddToCart, {
                isolatedCartType: _teko_cart_v2__WEBPACK_IMPORTED_MODULE_17__/* .IsolatedCartType.BUY_NOW */ .oG.BUY_NOW,
                isSkipHoldInventory: true
            });
            // in app
            if (_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_2__/* ["default"].isAvailable */ .Z.isAvailable()) {
                const cartToken = (0,helpers__WEBPACK_IMPORTED_MODULE_10__/* .getHamperDataLocalConfigs */ .TK)().cartToken;
                if (cartToken) {
                    const products = customHamperSkusAddToCart.map((item)=>{
                        var ref, ref1;
                        return _objectSpreadProps(_objectSpread({}, item), {
                            name: ((ref1 = (ref = hamperDetailProducts.products) === null || ref === void 0 ? void 0 : ref.find((p)=>p.sku === item.sku)) === null || ref1 === void 0 ? void 0 : ref1.name) || ""
                        });
                    });
                    const note = (0,helpers__WEBPACK_IMPORTED_MODULE_10__/* .buildHamperNote */ .$w)(hamperData, products);
                    (0,helpers__WEBPACK_IMPORTED_MODULE_10__/* .observeCheckoutHamperResult */ .DH)({
                        token: cartToken || "",
                        note,
                        cartType: _terra_js_terra_kit_dist_common_CommonKitModule__WEBPACK_IMPORTED_MODULE_3__.CartType.GIFT_BASKET
                    });
                } else {
                    var ref1;
                    toast === null || toast === void 0 ? void 0 : (ref1 = toast.error) === null || ref1 === void 0 ? void 0 : ref1.call(toast, {
                        title: (0,i18n__WEBPACK_IMPORTED_MODULE_13__.t)("Error"),
                        message: (0,i18n__WEBPACK_IMPORTED_MODULE_13__.t)("Kh\xf4ng lấy được cart token. Vui l\xf2ng thử lại!")
                    });
                }
            } else {
                // Redirect to checkout page
                const key = (0,_teko_cart_v2__WEBPACK_IMPORTED_MODULE_17__/* .getBuyNowKey */ .B2)(true);
                router.push("/checkout?bnk=".concat(key, "&isFromBom=true"));
            }
        } catch (error) {
            _teko_log__WEBPACK_IMPORTED_MODULE_1__/* .logger.log */ .k.log(error, "Add hamper to cart failed");
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HamperContext.Provider, {
        value: {
            hamperData,
            currentHamperConfig,
            changeActiveConfig,
            updateCurrentConfig,
            onUpdateConfig,
            hamperDetailProducts: hamperDetailProducts,
            loading: loading || isLoading,
            increaseHamperItemQuantity,
            decreaseHamperItemQuantity,
            removeHamperItem,
            setHamperItemQuantity,
            increaseCurrentHamperQuantity,
            decreaseCurrentHamperQuantity,
            setCurrentHamperQuantity,
            addHamper,
            onChangeQuantityHamper,
            minusHamper,
            removeHamper,
            productHampers,
            setProductHampers,
            priceSummary,
            priceAvailableHamper,
            allPriceSummary,
            handleBuyNowHamper,
            availableHamper
        },
        children: children
    });
};
const useHamper = ()=>{
    const context = (0,react__WEBPACK_IMPORTED_MODULE_5__.useContext)(HamperContext);
    if (!context) {
        throw new Error("useHamper must be inside a HamperProvider with a state value");
    }
    return context;
};


/***/ }),

/***/ 282116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$w": function() { return /* binding */ buildHamperNote; },
/* harmony export */   "DH": function() { return /* binding */ observeCheckoutHamperResult; },
/* harmony export */   "JQ": function() { return /* binding */ MAXIMUM_COUNT_HAMPER; },
/* harmony export */   "TK": function() { return /* binding */ getHamperDataLocalConfigs; }
/* harmony export */ });
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(535820);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(679376);
/* harmony import */ var _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(735090);
/* harmony import */ var _constants_hamper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(467327);



const MAXIMUM_COUNT_HAMPER = 5;
const getHamperDataLocalConfigs = ()=>{
    let result = {
        configs: [
            {
                quantity: 0
            },
            {
                quantity: 0
            },
            {
                quantity: 0
            },
            {
                quantity: 0
            },
            {
                quantity: 0
            }, 
        ],
        activeIndex: 0,
        hampers: []
    };
    const hamperKey = _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isAvailable */ .Z.isAvailable() ? _constants_hamper__WEBPACK_IMPORTED_MODULE_1__/* .CUSTOM_HAMPER_LOCAL_STORAGE_APP_KEY */ .Qj : _constants_hamper__WEBPACK_IMPORTED_MODULE_1__/* .CUSTOM_HAMPER_LOCAL_STORAGE_KEY */ .BJ;
    const hamperLocalConfigs =  true ? localStorage.getItem(hamperKey) : 0;
    if (!!hamperLocalConfigs && !(0,_teko_utils__WEBPACK_IMPORTED_MODULE_2__/* .isEmptyObject */ .Q)((0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .parseJsonStringSafely */ .O)(hamperLocalConfigs))) {
        const hamperConfig = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .parseJsonStringSafely */ .O)(hamperLocalConfigs);
        if (!!hamperConfig.configs) {
            const countLackHamper = MAXIMUM_COUNT_HAMPER - hamperConfig.configs.length;
            for(let i = 0; i < countLackHamper; i++){
                hamperConfig.configs.push({
                    quantity: 0
                });
            }
        }
        result = {
            configs: hamperConfig.configs || [
                {
                    quantity: 0
                },
                {
                    quantity: 0
                },
                {
                    quantity: 0
                },
                {
                    quantity: 0
                },
                {
                    quantity: 0
                }, 
            ],
            activeIndex: hamperConfig.activeIndex || 0,
            hampers: hamperConfig.hampers || [],
            cartToken: hamperConfig.cartToken
        };
    }
    return result;
};
const buildHamperNote = (hamper, flattenItems)=>{
    const flattenItemsBySku = new Map(flattenItems.map((item)=>[
            item.sku,
            item
        ]));
    const hamperNoteParts = [];
    hamper.configs.forEach((cfg, index)=>{
        if (cfg.quantity !== 0) {
            const lines = [];
            lines.push("Giỏ tự build ".concat(index + 1, " (SL: ").concat(cfg.quantity, "):"));
            Object.values(cfg).forEach((value)=>{
                if (Array.isArray(value)) {
                    value.forEach((item)=>{
                        var ref;
                        const name = (ref = flattenItemsBySku.get(item.sku)) === null || ref === void 0 ? void 0 : ref.name;
                        if (name) {
                            lines.push("- ".concat(item.quantity, "x ").concat(name));
                        }
                    });
                }
            });
            hamperNoteParts.push(lines.join("\n"));
        }
    });
    return hamperNoteParts.join("\n\n");
};
const observeCheckoutHamperResult = (params)=>{
    if (_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isAvailable */ .Z.isAvailable()) {
        _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__/* ["default"].common */ .Z.common().openBuyNow(params).subscribe({
            next: (param)=>{
                let { result  } = param;
                // Remove key buildHamperApp in LS
                if (result) localStorage.removeItem(_constants_hamper__WEBPACK_IMPORTED_MODULE_1__/* .CUSTOM_HAMPER_LOCAL_STORAGE_APP_KEY */ .Qj);
            }
        });
    }
};


/***/ }),

/***/ 347822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ scrollSmoothToIdWithOffset; },
/* harmony export */   "a": function() { return /* binding */ scrollSmoothToId; }
/* harmony export */ });
const scrollSmoothToId = (id)=>{
    const element = document.getElementById(id);
    element === null || element === void 0 ? void 0 : element.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest"
    });
};
const scrollSmoothToIdWithOffset = function(id) {
    let offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 90;
    const element = document.getElementById(id);
    if (!element) return;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.scrollY - offset;
    window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
    });
};


/***/ }),

/***/ 162831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useTerraScreenConfig; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var helpers_terra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(632843);


const useTerraScreenConfig = ()=>{
    const { 0: screenConfig , 1: setScreenConfig  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        (async ()=>{
            const config = await helpers_terra__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getScreenConfig */ .Z.getScreenConfig();
            setScreenConfig(config);
        })();
    }, []);
    return screenConfig;
};


/***/ }),

/***/ 127795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ PbPage; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-core-elements-virtual-e5082c0a27/0/cache/@tempi-core-elements-npm-1.0.80-7b0f8e7614-fde72c3b78.zip/node_modules/@tempi/core-elements/dist/renderer.js
var renderer = __webpack_require__(991551);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-207ba559a9/0/cache/@tempi-core-renderer-npm-1.0.80-d7700bdda7-e7885ad272.zip/node_modules/@tempi/core-renderer/dist/render.es.js
var render_es = __webpack_require__(539597);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-207ba559a9/0/cache/@tempi-core-renderer-npm-1.0.80-d7700bdda7-e7885ad272.zip/node_modules/@tempi/core-renderer/dist/utils/render.es.js
var utils_render_es = __webpack_require__(144765);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-ecom-elements-virtual-67188e0932/0/cache/@tempi-ecom-elements-npm-1.0.80-f1a1c73da4-bf2a952ffc.zip/node_modules/@tempi/ecom-elements/dist/renderer.js
var dist_renderer = __webpack_require__(336909);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./hooks/useTerraScreenConfig.ts
var useTerraScreenConfig = __webpack_require__(162831);
// EXTERNAL MODULE: ./modules/page-builder/slots/index.ts
var slots = __webpack_require__(164821);
// EXTERNAL MODULE: ../../.yarn/__virtual__/swr-virtual-976cccc57b/0/cache/swr-npm-1.1.2-8ec1c9a7ac-84bf222c66.zip/node_modules/swr/dist/index.esm.js
var index_esm = __webpack_require__(859676);
// EXTERNAL MODULE: ./modules/page-builder/service.ts + 1 modules
var service = __webpack_require__(137697);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var next_router = __webpack_require__(35304);
// EXTERNAL MODULE: ./constants/local.ts
var local = __webpack_require__(479228);
// EXTERNAL MODULE: ./helpers/env.ts
var env = __webpack_require__(353632);
;// CONCATENATED MODULE: ./modules/page-builder/hooks/usePbPage.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






const usePbPage = (param)=>{
    let { page , device , defaultValue  } = param;
    const { tempiWebsiteDomain , epicEcom480 , showPbPagesFromWebsiteEditor , isMobile ,  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const router = (0,next_router.useRouter)();
    const terminalIdFromCookies = (0,env/* getUserSelectedInfo */.Sk)(local/* userSelectedConstants.TERMINAL_ID */.Tp.TERMINAL_ID, isMobile, true);
    const terminalId = terminalIdFromCookies ? Number(terminalIdFromCookies) : undefined;
    const enableOmni1524 = // config must be true
    showPbPagesFromWebsiteEditor && // path should be buildpc page
    router.asPath.includes("buildpc") && // path is not a collection or landing page
    // e.g: /buildpc --> enable; /p/buildpc --> disable
    !new RegExp(/\/([c|p]+)\//).test(router.asPath);
    const { data , error , isValidating  } = (0,index_esm/* default */.ZP)([
        page,
        device,
        terminalIdFromCookies
    ], async (page, device)=>{
        var ref, ref1;
        const builder = new service/* PbService */.N(epicEcom480 || enableOmni1524 ? tempiWebsiteDomain || "" : (window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.hostname) || "", window === null || window === void 0 ? void 0 : (ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.hostname, epicEcom480 || enableOmni1524 || false);
        const { content , menu , websiteId  } = await builder.getContentPage(page, device, terminalId);
        return {
            content,
            menu,
            websiteId
        };
    }, {
        fallbackData: defaultValue,
        revalidateOnFocus: false
    });
    return _objectSpreadProps(_objectSpread({}, data), {
        error,
        loading: isValidating
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(85470);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-b1561bfdfb/1/packages/auth-react/dist/context.es.js + 1 modules
var context_es = __webpack_require__(423942);
// EXTERNAL MODULE: ../../.yarn/cache/@terra-js-terra-kit-npm-1.6.1-MOBCOMMON8280.1-1e45f776fe-3f3a8e4de1.zip/node_modules/@terra-js/terra-kit/dist/index.js
var dist = __webpack_require__(735090);
;// CONCATENATED MODULE: ./modules/page-builder/page.tsx
function page_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function page_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            page_defineProperty(target, key, source[key]);
        });
    }
    return target;
}












const BackButtonHeaderMobile = dynamic_default()(()=>__webpack_require__.e(/* import() */ 49124).then(__webpack_require__.bind(__webpack_require__, 749124)).then((f)=>f.BackButtonHeaderMobile), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(749124)
            ]
    }
});
const PbPage = (param)=>{
    let { pbContent: serverContent , pbSSRData , menu: serverMenu , page ="/"  } = param;
    var ref;
    const { isMobile , terminal , location , terminalId  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const device = isMobile ? "mobile" : "desktop";
    const { content , menu , websiteId  } = usePbPage({
        page: page,
        device,
        defaultValue: {
            content: serverContent,
            menu: serverMenu || []
        }
    });
    const { partner , getProcessEnv , isDisableLuckyDrawPhoneInput  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const screenConfig = (0,useTerraScreenConfig/* useTerraScreenConfig */.a)();
    const backappUrl = getProcessEnv("BACKAPP_URL");
    const { user  } = (0,context_es/* useAuth */.aC)();
    const { 0: appUserPhone , 1: setAppUserPhone  } = (0,react.useState)();
    const { 0: appUserLoading , 1: setAppUserLoading  } = (0,react.useState)(true);
    const showBackButton = !(screenConfig === null || screenConfig === void 0 ? void 0 : (ref = screenConfig.header) === null || ref === void 0 ? void 0 : ref.isBackIconHidden) && (!!partner || !!backappUrl);
    const mappingDynamicMobileSlotsAddNew = page_objectSpread({}, slots/* mappingDynamicMobileSlots */.Q, showBackButton ? {
        back_button_header_mobile: BackButtonHeaderMobile
    } : {});
    const mappingDynamicSlots = device === "mobile" ? mappingDynamicMobileSlotsAddNew : slots/* mappingDynamicDesktopSlots */.B;
    (0,react.useEffect)(()=>{
        if (dist/* default.isAvailable */.Z.isAvailable()) {
            setAppUserLoading(true);
            dist/* default.user */.Z.user().getUserProfile().then((appProfile)=>{
                var ref;
                const userPhone = (ref = appProfile.value) === null || ref === void 0 ? void 0 : ref.telephone;
                if (userPhone) {
                    setAppUserPhone(userPhone);
                }
            }).finally(()=>{
                setAppUserLoading(false);
            });
        } else {
            setAppUserLoading(false);
        }
    }, []);
    if (appUserLoading) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(render_es/* BuilderComponent */.V, {
        componentDict: (0,utils_render_es/* buildComponentDict */.Oq)(page_objectSpread({}, dist_renderer/* components */.w, renderer/* components */.w)),
        content: content,
        ssrData: pbSSRData,
        configs: {
            device,
            env: (0,env/* getEnv */.dU)("LANDING_BUILDER_ENV"),
            globalData: {
                menu,
                userPhoneNumber: (user === null || user === void 0 ? void 0 : user.telephone) || // in case webview in app consumer
                appUserPhone,
                isDisableLuckyDrawPhoneInput,
                websiteId,
                generateCustomUrl: (slug)=>{
                    var ref;
                    return "https://".concat(window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.hostname, "/").concat(slug);
                }
            },
            terminalCode: terminal,
            terminalId: terminalId,
            locationCode: location,
            mappingDynamicSlots,
            featureFlags: {
                flagPB5049: true
            }
        }
    });
};


/***/ }),

/***/ 137697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ PbService; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-ecom-elements-virtual-67188e0932/0/cache/@tempi-ecom-elements-npm-1.0.80-f1a1c73da4-bf2a952ffc.zip/node_modules/@tempi/ecom-elements/dist/constants/dynamic-block.js
var dynamic_block = __webpack_require__(906715);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-ecom-elements-virtual-67188e0932/0/cache/@tempi-ecom-elements-npm-1.0.80-f1a1c73da4-bf2a952ffc.zip/node_modules/@tempi/ecom-elements/dist/utils/getSlotData.js
var getSlotData = __webpack_require__(292623);
// EXTERNAL MODULE: ./helpers/env.ts
var helpers_env = __webpack_require__(353632);
// EXTERNAL MODULE: ./helpers/index.ts
var helpers = __webpack_require__(788813);
;// CONCATENATED MODULE: ./modules/page-builder/helper.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
/**
 * remove a key from content
 * a key can have one or more children
 * so we need to remove the key and all its children
 *
 * write a recursive function to remove the key and its children
 *
 * @param key
 * @param content
 */ const removeComponentByKey = (key, content)=>{
    let newContent = _objectSpread({}, content);
    if (!newContent[key]) {
        return newContent;
    }
    if (newContent[key].children) {
        newContent[key].children.forEach((child)=>{
            newContent = removeComponentByKey(child, newContent);
        });
    }
    delete newContent[key];
    return newContent;
};
/**
 * get all config from content with a given id
 * a component can have one or more children
 * so we need to get the component and all its children
 *
 * write a recursive function to get the component and its children
 *
 * @param id
 * @param content
 */ const getContentById = function(id) {
    let content = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    let result = {};
    if (content[id]) {
        var ref, ref1;
        result = _objectSpread({
            [id]: content[id]
        }, _objectSpread({}, (ref = content[id]) === null || ref === void 0 ? void 0 : (ref1 = ref.children) === null || ref1 === void 0 ? void 0 : ref1.reduce((acc, child)=>{
            return _objectSpread({}, acc, getContentById(child, content));
        }, {})));
    }
    return result;
};

;// CONCATENATED MODULE: ./modules/page-builder/service.ts
function service_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function service_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            service_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




class PbService {
    async getBuilder() {
        if (!this.builder) {
            this.builder = await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 828546)).then((f)=>f.builder).then((builder)=>{
                builder.init(this.domain, service_objectSpread({}, this.configs));
                return builder;
            });
        }
        return this.builder;
    }
    async getPublicPageV2() {
        let page = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "/", device = arguments.length > 1 ? arguments[1] : void 0, terminalId = arguments.length > 2 ? arguments[2] : void 0;
        const builder = await this.getBuilder();
        return builder.getPublicPageV2({
            slug: page,
            device,
            appliedDomain: this.appliedDomain,
            terminalId
        });
    }
    async getSSRInputs(content, device) {
        const builder = await this.getBuilder();
        return builder.getSSRInputs(// I'm not so sure about this assertion :(
        content, {
            device,
            ssrComponentTags: dynamic_block.SSR_COMPONENT_TAGS,
            getSlotDataFunc: getSlotData/* getSlotData */.P
        });
    }
    /**
   * only return content config, exclude header, footer
   * @returns
   * @param page
   * @param device
   */ async getContentPage(page, device, terminalId) {
        const res = await this.getPublicPageV2(page, device, terminalId);
        let content = service_objectSpread({}, res.content);
        content = removeComponentByKey("FOOTER", removeComponentByKey("HEADER", content));
        //  remove key Header and footer in root content
        content["ROOT"].children = content["ROOT"].children.filter((id)=>id !== "HEADER" && id !== "FOOTER");
        return _objectSpreadProps(service_objectSpread({}, res), {
            content
        });
    }
    /**
   * only return layout config
   * include header, footer, root and its children
   */ async getLayoutPage(device) {
        const _ref = await this.getPublicPageV2("404", device), { content  } = _ref, res = _objectWithoutProperties(_ref, [
            "content"
        ]);
        return _objectSpreadProps(service_objectSpread({}, res), {
            layoutConfig: {
                header: getContentById("HEADER", content),
                footer: getContentById("FOOTER", content)
            }
        });
    }
    constructor(host, appliedDomain, isEpicEcom480){
        const env = (0,helpers_env/* getEnv */.dU)("LANDING_BUILDER_ENV") || "dev";
        this.domain = isEpicEcom480 ? host : (0,helpers/* getLocalDomain */.Hw)(host, env);
        const epicEcom480Phase2 = (0,helpers_env/* getEnv */.dU)("EPIC_ECOM_480_PHASE_2") === "enabled";
        if (epicEcom480Phase2) {
            this.appliedDomain = (0,helpers/* getLocalDomain */.Hw)(appliedDomain, env);
        }
        this.configs = {
            env: (0,helpers/* isServerless */.ep)() ? env : "internal"
        };
    }
}


/***/ }),

/***/ 164821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ mappingDynamicDesktopSlots; },
/* harmony export */   "Q": function() { return /* binding */ mappingDynamicMobileSlots; }
/* harmony export */ });
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_0__);

const ProductGridDesktopSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(29078), __webpack_require__.e(47728), __webpack_require__.e(88837), __webpack_require__.e(22859), __webpack_require__.e(39486), __webpack_require__.e(77711), __webpack_require__.e(20833)]).then(__webpack_require__.bind(__webpack_require__, 98643)).then((f)=>f.ProductGridSlot.desktop), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(98643)
            ]
    }
});
const ProductGridMobileSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(29078), __webpack_require__.e(47728), __webpack_require__.e(88837), __webpack_require__.e(22859), __webpack_require__.e(39486), __webpack_require__.e(77711), __webpack_require__.e(20833)]).then(__webpack_require__.bind(__webpack_require__, 98643)).then((f)=>f.ProductGridSlot.mobile), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(98643)
            ]
    }
});
const ProductCarouselSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(90400), __webpack_require__.e(29078), __webpack_require__.e(47728), __webpack_require__.e(88837), __webpack_require__.e(22859), __webpack_require__.e(39486), __webpack_require__.e(77711), __webpack_require__.e(67032)]).then(__webpack_require__.bind(__webpack_require__, 82041)).then((f)=>f.LazyProductCarouselSlot), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(82041)
            ]
    }
});
const HamperCarouselSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(90400), __webpack_require__.e(29078), __webpack_require__.e(47728), __webpack_require__.e(88837), __webpack_require__.e(22859), __webpack_require__.e(39486), __webpack_require__.e(70330), __webpack_require__.e(77711), __webpack_require__.e(89887)]).then(__webpack_require__.bind(__webpack_require__, 867810)).then((f)=>f.LazyHamperCarouselSlot), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(867810)
            ]
    }
});
const NewLayoutProductCarouselSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(90400), __webpack_require__.e(29078), __webpack_require__.e(47728), __webpack_require__.e(88837), __webpack_require__.e(22859), __webpack_require__.e(39486), __webpack_require__.e(77711), __webpack_require__.e(67032)]).then(__webpack_require__.bind(__webpack_require__, 82041)).then((f)=>f.LazyNewLayoutProductCarouselSlot), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(82041)
            ]
    }
});
const PendingPaymentSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(4545), __webpack_require__.e(10433), __webpack_require__.e(7325), __webpack_require__.e(91141)]).then(__webpack_require__.bind(__webpack_require__, 512588)).then((f)=>f.PendingPaymentSlot), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(512588)
            ]
    }
});
const RecentProductMobileSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(90400), __webpack_require__.e(29078), __webpack_require__.e(39840), __webpack_require__.e(88837), __webpack_require__.e(22859), __webpack_require__.e(31038)]).then(__webpack_require__.bind(__webpack_require__, 770463)).then((f)=>f.LazyRecentProductMobileSlot), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(770463)
            ]
    }
});
const RecentProductDesktopSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(90400), __webpack_require__.e(29078), __webpack_require__.e(39840), __webpack_require__.e(88837), __webpack_require__.e(22859), __webpack_require__.e(31038)]).then(__webpack_require__.bind(__webpack_require__, 770463)).then((f)=>f.LazyRecentProductDesktopSlot), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(770463)
            ]
    }
});
const RecentSearchSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>__webpack_require__.e(/* import() */ 40403).then(__webpack_require__.bind(__webpack_require__, 840403)).then((f)=>f.LazyRecentSearchSlot), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(840403)
            ]
    }
});
const HeaderSearchDesktopSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(60367), __webpack_require__.e(29570)]).then(__webpack_require__.bind(__webpack_require__, 768493)).then((f)=>f.HeaderSearchSlot.desktop), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(768493)
            ]
    }
});
const HeaderSearchMobileSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(60367), __webpack_require__.e(29570)]).then(__webpack_require__.bind(__webpack_require__, 768493)).then((f)=>f.HeaderSearchSlot.mobile), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(768493)
            ]
    }
});
const HeaderRightItemDesktopSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(10433), __webpack_require__.e(61431), __webpack_require__.e(16508), __webpack_require__.e(60367), __webpack_require__.e(8916), __webpack_require__.e(1208), __webpack_require__.e(43878)]).then(__webpack_require__.bind(__webpack_require__, 265987)).then((f)=>f.HeaderRightItemSlot.desktop), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(265987)
            ]
    }
});
const HeaderRightItemMobileSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(10433), __webpack_require__.e(61431), __webpack_require__.e(16508), __webpack_require__.e(60367), __webpack_require__.e(8916), __webpack_require__.e(1208), __webpack_require__.e(43878)]).then(__webpack_require__.bind(__webpack_require__, 265987)).then((f)=>f.HeaderRightItemSlot.mobile), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(265987)
            ]
    }
});
const SearchBarRightItemsMobile = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(60367), __webpack_require__.e(29570)]).then(__webpack_require__.bind(__webpack_require__, 768493)).then((f)=>f.SearchBarRightItemsMobile), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(768493)
            ]
    }
});
const LocationPickerHeaderMobile = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>__webpack_require__.e(/* import() */ 73212).then(__webpack_require__.bind(__webpack_require__, 673212)).then((f)=>f.LocationPickerHeaderMobile), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(673212)
            ]
    }
});
const BuildPCPickerDesktopSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(29078), __webpack_require__.e(91592), __webpack_require__.e(71303), __webpack_require__.e(11103), __webpack_require__.e(88837), __webpack_require__.e(22859), __webpack_require__.e(76698), __webpack_require__.e(60687), __webpack_require__.e(57616), __webpack_require__.e(39486), __webpack_require__.e(23540), __webpack_require__.e(70330), __webpack_require__.e(48732), __webpack_require__.e(46149), __webpack_require__.e(47654)]).then(__webpack_require__.bind(__webpack_require__, 968887)).then((f)=>f.BuildPCPickerDesktopSlot), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(968887)
            ]
    }
});
const BuildPCPickerMobileSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(29078), __webpack_require__.e(91592), __webpack_require__.e(71303), __webpack_require__.e(11103), __webpack_require__.e(88837), __webpack_require__.e(22859), __webpack_require__.e(76698), __webpack_require__.e(60687), __webpack_require__.e(57616), __webpack_require__.e(39486), __webpack_require__.e(23540), __webpack_require__.e(70330), __webpack_require__.e(48732), __webpack_require__.e(46149), __webpack_require__.e(47654)]).then(__webpack_require__.bind(__webpack_require__, 968887)).then((f)=>f.BuildPCPickerMobileSlot), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(968887)
            ]
    }
});
const CustomHamperDesktopSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(29078), __webpack_require__.e(91592), __webpack_require__.e(71303), __webpack_require__.e(73663), __webpack_require__.e(11103), __webpack_require__.e(88837), __webpack_require__.e(22859), __webpack_require__.e(76698), __webpack_require__.e(60687), __webpack_require__.e(39486), __webpack_require__.e(23540), __webpack_require__.e(70330), __webpack_require__.e(48732), __webpack_require__.e(46149), __webpack_require__.e(92239), __webpack_require__.e(29091)]).then(__webpack_require__.bind(__webpack_require__, 846777)).then((f)=>f.CustomHamperDesktopSlot), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(846777)
            ]
    }
});
const CustomHamperMobileSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(29078), __webpack_require__.e(91592), __webpack_require__.e(71303), __webpack_require__.e(73663), __webpack_require__.e(11103), __webpack_require__.e(88837), __webpack_require__.e(22859), __webpack_require__.e(76698), __webpack_require__.e(60687), __webpack_require__.e(39486), __webpack_require__.e(23540), __webpack_require__.e(70330), __webpack_require__.e(48732), __webpack_require__.e(46149), __webpack_require__.e(92239), __webpack_require__.e(29091)]).then(__webpack_require__.bind(__webpack_require__, 846777)).then((f)=>f.CustomHamperMobileSlot), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(846777)
            ]
    }
});
const LeftBannerProductMobileSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(29078), __webpack_require__.e(47728), __webpack_require__.e(88837), __webpack_require__.e(22859), __webpack_require__.e(39486), __webpack_require__.e(77711), __webpack_require__.e(47919)]).then(__webpack_require__.bind(__webpack_require__, 937206)).then((f)=>f.LazyLeftBannerProductMobileSlot), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(937206)
            ]
    }
});
const VideoPreviewCarouselSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(88837), __webpack_require__.e(39486), __webpack_require__.e(88667)]).then(__webpack_require__.bind(__webpack_require__, 813086)).then((f)=>f.LazyVideoPreviewCarousel), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(813086)
            ]
    }
});
const RecommendProductModalSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(90400), __webpack_require__.e(61646), __webpack_require__.e(88837), __webpack_require__.e(86914)]).then(__webpack_require__.bind(__webpack_require__, 686914)).then((f)=>f.RecommendProductModalSlot), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(686914)
            ]
    }
});
const mappingDynamicDesktopSlots = {
    product_grid_desktop: ProductGridDesktopSlot,
    product_carousel_desktop: ProductCarouselSlot,
    hamper_carousel_desktop: HamperCarouselSlot,
    recent_product: RecentProductDesktopSlot,
    header_search_desktop: HeaderSearchDesktopSlot,
    header_right_items_desktop: HeaderRightItemDesktopSlot,
    build_pc: BuildPCPickerDesktopSlot,
    new_layout_product_carousel_desktop: NewLayoutProductCarouselSlot,
    video_preview_carouse: VideoPreviewCarouselSlot,
    custom_hamper: CustomHamperDesktopSlot,
    modal_recommend_product: RecommendProductModalSlot
};
const mappingDynamicMobileSlots = {
    product_grid_mobile: ProductGridMobileSlot,
    product_carousel_mobile: ProductCarouselSlot,
    hamper_carousel_mobile: HamperCarouselSlot,
    pending_payment: PendingPaymentSlot,
    recent_product: RecentProductMobileSlot,
    recent_search: RecentSearchSlot,
    header_search_mobile: HeaderSearchMobileSlot,
    header_right_items_mobile: HeaderRightItemMobileSlot,
    search_bar_right_items_mobile: SearchBarRightItemsMobile,
    build_pc: BuildPCPickerMobileSlot,
    left_banner_product_mobile: LeftBannerProductMobileSlot,
    location_picker_header_mobile: LocationPickerHeaderMobile,
    new_layout_product_carousel_mobile: NewLayoutProductCarouselSlot,
    video_preview_carouse: VideoPreviewCarouselSlot,
    custom_hamper: CustomHamperMobileSlot,
    modal_recommend_product: RecommendProductModalSlot
};


/***/ }),

/***/ 353120:
/***/ (function() {

/* (ignored) */

/***/ })

}]);